/**
 * These functions exist to be backwards-compatible with the date-fns-tz public
 * interface. If these don't do what you want as-is, prefer using the
 * `@date-fns/tz` packages directly.
 */

import { tz } from "@date-fns/tz";
import { toDate, transpose } from "date-fns";

export function utcToZonedTime(date: Date | string, timeZone: string): Date {
  timeZone = timeZone === "Z" ? "UTC" : timeZone;
  return transpose(toDate(date, tz(timeZone)), toDate);
}
